<template>
  <!-- "Cancellation not directly supported" · warning-toned panel listing the beneficiaries whose
       registry cannot cancel directly. Shared by the GO-cancel editor (informational) and bulk-buy
       (which slots in a mode-selection control below the badges). Outer margin is left to the caller
       via class fallthrough, matching RegionMismatchAdvisory. -->
  <div
    class="rounded-3 border border-warning-subtle bg-warning-subtle text-warning-emphasis p-3"
  >
    <div class="d-flex align-items-center gap-2 mb-2">
      <FontAwesomeIcon icon="exclamation-triangle" class="flex-shrink-0" />
      <span class="fw-semibold">{{
        t("bulk_buy.cancellation_not_supported_title")
      }}</span>
    </div>
    <p class="small mb-2">
      {{ t("bulk_buy.cancellation_not_supported_description") }}
    </p>
    <div class="d-flex flex-wrap gap-1">
      <span
        v-for="entry in entries"
        :key="entry.key"
        class="badge bg-secondary"
      >
        {{ entry.name }} ({{ entry.region }})
      </span>
    </div>
    <!-- Bulk-buy slots its agent/registry mode radios here; the editor leaves it empty. -->
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

export interface UnsupportedRegistryEntry {
  key: string;
  name: string;
  region: string;
}

defineProps<{
  entries: UnsupportedRegistryEntry[];
}>();

const { t } = useI18n();
</script>
